import { useState, useEffect } from 'react';
import { useCart } from '../context/CartContext.jsx';
import { imageUrl, srcSet, fmtPrice } from '../shopData.js';

export function CartSheet() {
  const { items, open, setOpen, updateQty, remove, subtotal, clear } = useCart();
  const [closing, setClosing] = useState(false);

  useEffect(() => {
    if (open && !closing) {
      setClosing(false);
    }
  }, [open]);

  const handleClose = () => {
    if (closing) return;
    setClosing(true);
    setTimeout(() => setOpen(false), 150); // matches cart-exit duration
  };

  const handleScrim = (e) => {
    if (e.target === e.currentTarget) handleClose();
  };

  const handleKey = (e) => {
    if (e.key === 'Escape') handleClose();
  };

  if (!open && !closing) return null;

  return (
    <div
      className="cart-sheet"
      role="dialog"
      aria-modal="true"
      aria-label="Shopping cart"
      onKeyDown={handleKey}
      // undefined, not false — see App.jsx Lightbox. "false" still matches [data-closing].
      data-closing={closing ? 'true' : undefined}
    >
      <div className="cart-sheet__scrim" onClick={handleScrim} />
      <aside className="cart-sheet__panel">
        <header className="cart-sheet__head">
          <h2>Cart ({items.length})</h2>
          <button className="cart-sheet__close" onClick={handleClose} aria-label="Close cart">
            <svg viewBox="0 0 24 24" width="18" height="18" fill="none" stroke="currentColor" strokeWidth="2" aria-hidden="true">
              <path d="M6 6l12 12M18 6L6 18" strokeLinecap="round" />
            </svg>
          </button>
        </header>

        {items.length === 0 ? (
          <div className="cart-sheet__empty">
            <p>Your cart is empty.</p>
            <a href="/shop" className="cart-sheet__cta" onClick={() => setOpen(false)}>
            Shop the uniform
          </a>
          </div>
        ) : (
          <>
            <ul className="cart-sheet__list" role="list">
              {items.map((item) => (
                <li key={item.key} className="cart-sheet__item">
                  <img
                    src={imageUrl(item.product)}
                    srcSet={srcSet(item.product)}
                    sizes="64px"
                    className="cart-sheet__thumb"
                  />
                  <div className="cart-sheet__info">
                    <p className="cart-sheet__name">{item.product.name}</p>
                    <p className="cart-sheet__meta">
                      {item.size} {fmtPrice(item.product.price)}
                    </p>
                    <div className="cart-sheet__qty">
                      <button
                        onClick={() => updateQty(item.key, item.qty - 1)}
                        aria-label="Decrease"
                      >
                        −
                      </button>
                      <span>{item.qty}</span>
                      <button
                        onClick={() => updateQty(item.key, item.qty + 1)}
                        aria-label="Increase"
                      >
                        +
                      </button>
                    </div>
                  </div>
                  <button
                    className="cart-sheet__remove"
                    onClick={() => remove(item.key)}
                    aria-label={`Remove ${item.product.name}`}
                  >
                    ×
                  </button>
                </li>
              ))}
            </ul>

            <div className="cart-sheet__total">
              <span>Subtotal</span>
              <strong>{fmtPrice(subtotal)}</strong>
            </div>

            <div className="cart-sheet__actions">
              <button
                className="btn btn--primary cart-sheet__checkout"
                disabled={items.length === 0}
              >
                Checkout
              </button>
              <button
                className="btn btn--ghost cart-sheet__clear"
                onClick={clear}
                disabled={items.length === 0}
              >
                Clear cart
              </button>
            </div>
          </>
        )}
      </aside>
    </div>
  );
}